export enum ActionButtonState {
	Enabled,
	DisabledNoPerms,
	DisabledInPast,
}

export default function ActionButton(props: {
	action_verb: string;
	button_class: string;
	font_awesome_class: string;
	state: ActionButtonState;
	on_click_func?: Function;
	hyperlink?: string;
	className?: string;
}) {
	let title: string;
	switch (props.state) {
		case ActionButtonState.Enabled:
			title = props.action_verb;
			break;
		case ActionButtonState.DisabledInPast:
			title = `Can not ${props.action_verb.toLowerCase()} event that has already started`;
			break;
		case ActionButtonState.DisabledNoPerms:
			title = `Invalid permissions to ${props.action_verb.toLowerCase()}`;
			break;
	}

	let className: string;
	let current_click_func: () => any;
	switch (props.state) {
		case ActionButtonState.Enabled:
			className = props.button_class;
			if (props.on_click_func) {
				current_click_func = () => props.on_click_func();
			}
			break;
		case ActionButtonState.DisabledInPast:
		case ActionButtonState.DisabledNoPerms:
			className = "action-icon-disabled";
			break;
	}

	if (props.hyperlink) {
		return (
			<div className={props.className}>
				<a
					className={className}
					data-tip={title}
					href={props.hyperlink}
					target="_blank"
				>
					<i className={props.font_awesome_class}></i>
				</a>
			</div>
		);
	} else {
		return (
			<div className={props.className}>
				<p
					className={className}
					onClick={current_click_func}
					data-tip={title}
				>
					<i className={props.font_awesome_class}></i>
				</p>
			</div>
		);
	}
}
